import { PriceNavigatorPagination } from '../types/price-navigator-pagination';

export const PRICE_NAVIGATOR_DEFAULT_PAGINATION: PriceNavigatorPagination = {
  limit: 20,
  offset: 0,
};
